import { AudienceDashboard } from '../../types/digital-audience/DigitalAudience';
import {
  DigitalAudienceDashboardActions,
  DigitalAudienceDashboardActionsType,
} from './DigitalAudienceDashboardActions';

export type DigitalAudienceDashboardState = {
  audiences: AudienceDashboard[];
};

const digitalAudienceDashboardState = (): DigitalAudienceDashboardState => ({
  audiences: [],
});

export const digitalAudienceDashboardReducer = (
  state: DigitalAudienceDashboardState = digitalAudienceDashboardState(),
  action: DigitalAudienceDashboardActions,
): DigitalAudienceDashboardState => {
  switch (action.type) {
    case DigitalAudienceDashboardActionsType.SET_DIGITAL_AUDIENCE_DASHBOARD_AUDIENCES: {
      return {
        ...state,
        audiences: action.payload.audiences.map((audience) => ({
          ...audience,
          autoRefreshUpdating: false,
        })),
      };
    }

    case DigitalAudienceDashboardActionsType.SET_DIGITAL_AUDIENCE_AUTO_REFRESH_UPDATING: {
      return {
        ...state,
        audiences: state.audiences.map((audience) => {
          if (audience.id === action.payload.audienceId) {
            return {
              ...audience,
              autoRefreshUpdating: action.payload.isUpdating,
            };
          }
          return audience;
        }),
      };
    }

    case DigitalAudienceDashboardActionsType.TOGGLE_AUDIENCE_AUTO_REFRESH: {
      return {
        ...state,
        audiences: state.audiences.map((audience) => {
          if (audience.id === action.payload.audienceId) {
            return {
              ...audience,
              autoRefreshEnabled: !audience.autoRefreshEnabled,
            };
          }
          return audience;
        }),
      };
    }

    default:
      return state;
  }
};
